import { createContext, useContext } from 'react';

export const AvailableToBillListTableContext = createContext();

export const useAvailableToBillListTableContext = () =>
  useContext(AvailableToBillListTableContext);

export default AvailableToBillListTableContext;
